import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { Component, OnInit, Injector, Input } from '@angular/core';
import { PrimeIcons } from 'primeng/api';
import { MoveOrderService } from '../../services/move-order.service';
import { ShipmentProgressEvent } from 'src/app/core/models/transport-operation/shipment-progress-event';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { ShipmentProgressPercent } from 'src/app/core/models/transport-operation/shipment-progess-percent';
import { DeliveryOrderService } from '../../services/delivery-order.service';
import { LicensePlateInfo } from 'src/app/core/models/transport-operation/license-plate-info';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  selector: 'laas-shipment-progress',
  templateUrl: './shipment-progress.component.html',
  styleUrls: ['./shipment-progress.component.scss']
})
export class ShipmentProgressComponent extends SessionBaseComponent implements OnInit {
  readonly viewPermissionCode = PermissionConstants.ViewQueryDoStatus;
  readonly preferenceKey: string = UserPreferenceConstants.ShipmentProgress;
  events: ShipmentProgressEvent[] = [];
  doNo: string = "";
  selectedRows: any[] = [];
  selectedCols: any[];
  moveOrders: any[] = [];
  moveOrderItems: any[] = [];
  columns: any[];
  tableColumns: any[];
  detailColumns: any[];
  MOStatusOptions: any[] = [];
  maxStatus: number = -1;
  doPercent: ShipmentProgressPercent | undefined;
  doStatus: any;
  priorityOptions:any = [];
  licensePlate: string = ''; //車號
  licensePlateInfo!: LicensePlateInfo;
  currentLang: string = this.laasSetting.language;

  constructor(
    injector: Injector,
    private MOService: MoveOrderService,
    private commonDataService: CommonDataService,
    private DOService: DeliveryOrderService,
  ) {
    super(injector);
    this.columns = [
      { field: 'facility', header: 'ShippingStatus.DetailTable.Facility' },
      { field: 'doNo', header: 'ShippingStatus.DetailTable.DONum' },
      { field: 'pdNo', header: 'ShippingStatus.DetailTable.MONum' },
      { field: 'moStatus', header: 'ShippingStatus.DetailTable.Status' },
      { field: 'cartonCnt', header: 'ShippingStatus.DetailTable.CartonCnt' },
      { field: 'priority', header: 'ShippingStatus.DetailTable.Priority' },
      { field: 'soldToName', header: 'ShippingStatus.DetailTable.Customer' },
      { field: 'fixedRemark', header: 'ShippingStatus.DetailTable.Remarks' },
      { field: 'moveOrderItems', header: 'moveOrderItems', showData: false}
    ];

    this.tableColumns = this.columns.slice(0, this.columns.length - 1);

    this.selectedCols = this.tableColumns;

    this.detailColumns = [
      { field: 'letterHeadOrgName', header: 'ShippingStatus.MODetailTable.Facility' },
      { field: 'deliveryType', header: 'ShippingStatus.MODetailTable.DeliveryType' },
      { field: 'pdNo', header: 'ShippingStatus.MODetailTable.MONum' },
      { field: 'sku', header: 'ShippingStatus.MODetailTable.ERPSku' },
      { field: 'altSku', header: 'ShippingStatus.MODetailTable.CustomerSku' },
      { field: 'originalQty', header: 'ShippingStatus.MODetailTable.Qty' },
    ];

  }

  @Input() get selectedColumns(): any[] {
    return this.selectedCols;
  }

  set selectedColumns(cols: any[]) {
    this.selectedCols = this.tableColumns.filter((col) => cols.includes(col));
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.doNo = this.routeStateService.getCurrent().data.doNo;
    this.MOService.getMoveOrderTrackingAndFixedRemark(this.doNo,this.laasSetting.facility).subscribe({
      next: (result) => {
        this.moveOrders = result;
        this.moveOrders.forEach(x => {
          this.MOService.getMoveOrderItemsByPDNo(x.pdNo).subscribe({
            next: (result) => {
              x.moveOrderItems = result;
              x.moveOrderItems.expanded = false;
            },
          });
        });
      },
    });

    this.events = [
      {status: 'ShippingStatus.Event.Allocated', stage: 0, progress: '0%', icon: 'far fa-cicle', color: '#ccc', image: 'game-controller.jpg'},
      {status: 'ShippingStatus.Event.PickedUp', stage: 1, progress: '0%', icon: 'far fa-cicle', color: '#ccc'},
      {status: 'ShippingStatus.Event.PackedOut', stage: 2, progress: '0%', icon: 'far fa-cicle', color: '#ccc'},
      {status: 'ShippingStatus.Event.LeftWarehouse', stage: 3, progress: '0%', icon: 'far fa-cicle', color: '#ccc'},
      {status: 'ShippingStatus.Event.Deliveried', stage: 4, progress: '0%', icon: 'far fa-cicle', color: '#ccc'}
    ];

    var estimatedDtResult = await this.MOService.getEstimatedDate(this.doNo).toPromise();

    var realDt = await this.DOService.getDoRealDate(this.doNo).toPromise();

    this.doPercent = await this.MOService.getMoveOrderTrackingPercent(this.doNo).toPromise();

    this.doStatus = await this.DOService.getShipmentProgressDoStatus(this.doNo).toPromise();

    this.events[0].estimatedDt = estimatedDtResult.estimatedAllocateDt;
    this.events[1].estimatedDt = estimatedDtResult.estimatedPickDt;
    this.events[2].estimatedDt = estimatedDtResult.estimatedDoorlaneDt;
    this.events[3].estimatedDt = estimatedDtResult.estimatedLeaveWarehouseDt;
    this.events[4].estimatedDt = estimatedDtResult.estimatedArrivalDt;
    this.events[4].tmsUrl = estimatedDtResult.tmsUrl;

    this.licensePlateInfo = await this.DOService.getLicensePlate(this.doNo).toPromise();
    console.log('licensePlateInfo = ' + this.licensePlateInfo);
    this.licensePlate = this.licensePlateInfo.licensePlate; //賦予車號
    this.events[3].gpsLinkFlag = this.licensePlateInfo.gpsLinkFlag; //修改這裡的flag顯示 GPSlink


    // 3 派工100 | 5 揀貨 抓WMS% | 8 箱到齊 抓WMS% | K 出倉 100 | O 到貨 100%
    realDt.forEach((track: any) => {
      switch (track.doStatus) {
        case '3':
          this.events[0].realDt = track.processDt;
          if (this.maxStatus < 0) {
            this.maxStatus = 0;
          }
          break;
        case '5':
          this.events[1].realDt = track.processDt;
          if (this.maxStatus < 1) {
            this.maxStatus = 1;
          }
          break;
        case '8':
          this.events[2].realDt = track.processDt;
          if (this.maxStatus < 2) {
            this.maxStatus = 2;
          }
          break;
        case 'K':
          this.events[3].realDt = track.processDt;
          if (this.maxStatus < 3) {
            this.maxStatus = 3;
          }
          break;
        case 'O':
          this.events[4].realDt = track.processDt;
          if (this.maxStatus < 4) {
            this.maxStatus = 4;
          }
          break;
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'MoStatus').subscribe({
      next: result => {
        this.MOStatusOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });


    this.updateIcon();

    if (this.laasSetting.language == 'en-us') {
      this.priorityOptions = [
        { label: '5 - Normal', value: '5' },
        { label: '1 - Urgent', value: '1' }
      ];
    } else if (this.laasSetting.language == 'zh-tw') {
      this.priorityOptions = [
        { label: '5 - 一般單', value: '5' },
        { label: '1 - 急單', value: '1' }
      ];
    }

  }

  updateIcon(): void{
    this.events.forEach((value, index) => {
      if (index <= this.maxStatus){
        value.icon = PrimeIcons.CHECK;
        value.color = '#9C27B0';
        value.progress = '0%';

        if (!isNullOrEmpty(value.realDt)){
          value.progress = '100%';
        }

        if (index == 1 ) {
          if (this.doPercent?.pickPercent == undefined || this.doPercent.pickPercent == null || isNullOrEmpty(this.doPercent.pickPercent || this.doPercent.pickPercent == 'null')) {
            value.progress = '100%'
          } else {
            value.progress = this.doPercent.pickPercent + '%';
          }
        }
        if (index == 2 ) {
          if (this.doPercent?.doorlanePercent == undefined || this.doPercent.doorlanePercent == null || isNullOrEmpty(this.doPercent.doorlanePercent) || this.doPercent.doorlanePercent == 'null') {
            value.progress = '100%'
          } else {
            value.progress = this.doPercent.doorlanePercent + '%';
          }
        }
      }
    });
  }

  gotoForwarderPage(event: Event, url: string): void{
    window.open(url);
  }

  rowToggleBtnClick(event: any, rowData: any, expanded: boolean): void {
    if (expanded === false) {
      this.MOService.getMoveOrderItemsByPDNo(rowData.pdNo).subscribe({
        next: (result) => {
          rowData.moveOrderItems = result;
        },
      });
    }
  }

  toggleBtnClick(event: any, moveOrderItems: any): void{
    moveOrderItems.expanded = moveOrderItems.expanded === false;
  }


  openNewPageWithGPS() {
    // 建立一個隱藏的 form 元素
    const form = document.createElement('form');
    form.method = 'POST';
    form.target = '_blank';
    form.action = 'http://175.99.76.212/APIMISC/Com_Map';

    // 建立一個隱藏的 input 元素，用於傳遞 API token
    const tokenInput = document.createElement('input');
    tokenInput.type = 'hidden';
    tokenInput.name = 'T';
    tokenInput.value = 'd52b6f790b95a9a0d38e07c0b53afc067994c76a';

    // 將 input 元素加入到 form 元素中
    form.appendChild(tokenInput);

    // 建立一個隱藏的 input 元素，用於傳遞 API token
    const tokenInput2 = document.createElement('input');
    tokenInput2.type = 'hidden';
    tokenInput2.name = 'V';
    tokenInput2.value = this.licensePlate;

    // 將 input 元素加入到 form 元素中
    form.appendChild(tokenInput2);

    // 將 form 元素加入頁面中
    document.body.appendChild(form);

    // 提交 form 元素，開啟新的分頁
    form.submit();
  }

}
